import styled from "styled-components";

export const SubmitReqPreStyled = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: ${({ theme }) =>
    !["xm"].includes(theme.windowWidth) ? "342px" : "100%"};

  padding: 36px;
  color: white;
  z-index: 3;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  overflow-y: auto;
  scrollbar-width: none;

  .slider-car {
    background-color: white;
    border-radius: 15px;
    color: black;
  }
`;
